/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminReopenMatchBody
 */
export interface AdminReopenMatchBody {
    /**
     * Why the result is being reopened. Recorded on the match and in the audit log.
     * @type {string}
     * @memberof AdminReopenMatchBody
     */
    reason: string;
}

/**
 * Check if a given object implements the AdminReopenMatchBody interface.
 */
export function instanceOfAdminReopenMatchBody(value: object): value is AdminReopenMatchBody {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function AdminReopenMatchBodyFromJSON(json: any): AdminReopenMatchBody {
    return AdminReopenMatchBodyFromJSONTyped(json, false);
}

export function AdminReopenMatchBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminReopenMatchBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function AdminReopenMatchBodyToJSON(json: any): AdminReopenMatchBody {
    return AdminReopenMatchBodyToJSONTyped(json, false);
}

export function AdminReopenMatchBodyToJSONTyped(value?: AdminReopenMatchBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

